import { render, staticRenderFns } from "./SiportLogs.vue?vue&type=template&id=4fc4bc20&"
import script from "./SiportLogs.vue?vue&type=script&lang=js&"
export * from "./SiportLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports